import { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "../queryClient.config.ts";
import UserContextExports from "../../context/UserContext.tsx";
import ToastContextExports from "../../context/ToastContext.tsx";
import { ToastInterceptorProvider } from "../axios.config.ts";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ChatProvider } from "../../context/ChatProvider.tsx";

type ProvidersProps = {
  children: ReactNode;
};

export default function Providers({ children }: ProvidersProps) {
  const appGoogleKey = import.meta.env.VITE_SOME_APP_GOOGLE_KEY;
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContextExports.Provider>
        <ToastInterceptorProvider>
          <UserContextExports.Provider>
            <GoogleOAuthProvider clientId={appGoogleKey}>
              <ChatProvider>{children}</ChatProvider>
            </GoogleOAuthProvider>
          </UserContextExports.Provider>
        </ToastInterceptorProvider>
      </ToastContextExports.Provider>
    </QueryClientProvider>
  );
}
